export default `query FetchSuccessReferrals {
  success_referrals {
    customer_avatar
    time_cash_amount
    referral_count
    customer_name
  }
}
`
